import dark from './dark';
import light from './light';
import isDark from '../../../common/verifiers/is-dark';

const primary = ({ infoColorPalette, backgroundColor }) => {
  if (isDark(backgroundColor)) {
    return dark({ infoColorPalette, backgroundColor });
  }

  return light({ infoColorPalette, backgroundColor });
};

export default primary;
